import { render, staticRenderFns } from "./ProjectPackage.vue?vue&type=template&id=77a6c8e8&scoped=true&"
import script from "./projectpackage.js?vue&type=script&lang=js&"
export * from "./projectpackage.js?vue&type=script&lang=js&"
import style0 from "./ProjectPackage.vue?vue&type=style&index=0&id=77a6c8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a6c8e8",
  null
  
)

export default component.exports